var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import cls from 'classnames';
import { Icon, Popup, tools } from 'rcm-mobile';
import './style/index.scss';
let getUuid;
let rootElement;
const toastInstance = {};
/**
 * @author sayll
 * @version 0.0.1
 */
export default class Toast extends React.PureComponent {
    render() {
        const _a = this.props, { prefixCls, className, children } = _a, resetProps = __rest(_a, ["prefixCls", "className", "children"]);
        return (<div className={cls(`${prefixCls}`, className)} {...resetProps}>
        {children}
      </div>);
    }
    // @ts-ignore
    static create(content, duration = 1500, callback, options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!getUuid) {
                getUuid = tools.helper.getUuidFn(Toast.defaultProps.prefixCls);
            }
            if (!rootElement) {
                rootElement = document.createElement('div');
                rootElement.className = `${Toast.defaultProps.prefixCls}-root`;
                document.body.appendChild(rootElement);
            }
            const key = getUuid();
            const sender = yield Popup.create(Object.assign({ content: <Toast>{content}</Toast>, mask: true, animation: 'zoomOut' }, options, { rootElement }), callback);
            toastInstance[key] = sender;
            if (duration) {
                setTimeout(() => {
                    toastInstance[key].destroy();
                    delete toastInstance[key];
                }, duration);
            }
            return sender;
        });
    }
    /**
     * 普通信息提示
     * @public
     * */
    // @ts-ignore
    static info(content, duration = 1500, callback, options) {
        return __awaiter(this, void 0, void 0, function* () {
            return Toast.create(<div>{content}</div>, duration, callback, options);
        });
    }
    /**
     * 错误信息提示
     * @public
     * */
    // @ts-ignore
    static error(content, duration = 1500, callback, options) {
        return Toast.create(<div>
      <div style={{ textAlign: 'center' }}><Icon className="x-icon-close-circle-o"/></div>
      {content}
    </div>, duration, callback, options);
    }
    /**
     * 警告信息提示
     * @public
     * */
    // @ts-ignore
    static warning(content, duration = 1500, callback, options) {
        return Toast.create(<div>
      <div style={{ textAlign: 'center' }}><Icon className="x-icon-warm"/></div>
      {content}
    </div>, duration, callback, options);
    }
    /**
     * 成功信息提示
     * @public
     * */
    // @ts-ignore
    static success(content, duration = 1500, callback, options) {
        return Toast.create(<div>
      <div style={{ textAlign: 'center' }}><Icon className="x-icon-check-circle-o"/></div>
      {content}
    </div>, duration, callback, options);
    }
    /**
     * 加载信息提示
     * @public
     * */
    // @ts-ignore
    static loading(content = '加载中...', duration = 0, callback, options) {
        return Toast.create(<div>
      <div style={{ textAlign: 'center' }}><Icon spin className="x-icon-loading"/></div>
      {content}
    </div>, duration, callback, options);
    }
    /**
     * 卸载所有Toast
     * @public
     * */
    static destroy() {
        return __awaiter(this, void 0, void 0, function* () {
            let sender;
            for (let key in toastInstance) {
                sender = yield toastInstance[key];
                sender.destroy();
                delete toastInstance[key];
            }
        });
    }
}
Toast.defaultProps = {
    prefixCls: 'x-toast'
};
